import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>
          © Copyright - 2023 <span>Gold Company</span>. All Rights Reserved
        </p>
      </div>
    </footer>
  );
}

export default Footer;